// Update Mac App's registration (docs/features/remote-mac-update.md): the window `macupdate` (one per Mac), the
// Mac's ⋯ › Update Mac App…, and the wire kind `update` (status · check · install → status; Home's badge reads
// link.update).
import { registerWindow } from '../../core/windows.js'
import { registerHomeItem } from '../../core/home-items.js'
import { registerWire } from '../../core/wire.js'

registerWindow('macupdate', { module: () => import('./macupdate.js'), css: 'windows/macupdate/macupdate.css', key: (a, key) => 'macupdate-' + (key || 'mac'), title: () => 'Update Mac App', place: ['home', 'trailing'] })
registerHomeItem({ id: 'macupdate', label: 'Update Mac App…', symbol: 'lucide:circle-arrow-down', needs: 'paired', section: 'mac', order: 20 })
registerWire('update', (link, payload, m) => { if (m?.what === 'status') { link.update = m; link.updateHeard = Date.now(); link.onUpdate?.(m) } })
